export const TEXT = {
  TITLE: {id: 'maintenance.title'},
  BODY: {id: 'maintenance.body'},
} as const;
